import React, { createRef, forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import API from '../../API';
import moment from 'moment';
import { createRoot } from 'react-dom/client';
import { DateThaiFormat, NumberFormat,DateFormatJSON } from '../../Utils/Function';
import parse from 'html-react-parser'
import { Controller, useForm } from "react-hook-form";
import ThaiDatePicker from '../ThaiDatePicker';
import {DataTable} from '..'

const TransactionCard = forwardRef((props, ref) => {
    const { register, handleSubmit, watch, reset, getValues, setValue, control, formState: { errors } } = useForm();
    const[_MemberID,setMemberID] = useState(null);
    const [_StartDate, setStartDate] = useState(moment().add(-7,'day').toDate());
    const [_EndDate, setEndDate] = useState(new Date());
    const [_StoreList,setStoreList] = useState([]);
    const _ref = useRef();
    useEffect(() => {
        (async () => {
            _LoadStoreList();
            setValue('Start',moment().add(-7,'day').toDate());
            setValue('End',new Date())
        })();

        return () => { }
    }, []);

    useImperativeHandle(ref, () => ({
         Show(MemberID){
            setMemberID(MemberID);
            setValue('MemberID',MemberID);
            setTimeout(()=>{
                ref.current?.load();
            },500);
        },
    }));

    const _LoadStoreList= async()=>{
        setStoreList([]);
        API({method : "get",url:"/Staff/Store/List"}).then(res=>{
                if (res.status !== 200) {
                    return;
                }

                if (!res.data.Status) {
                    return;
                }
                setStoreList(res.data.Data);
        }).catch(res => {
                return;
        });
    }
    const _configs = {
        "order": [[0, "desc"]],
        pageLength: 10,
        orderMulti: true
    }
    
    const _ajax  = {
        'url': '/Report/Sale/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.MemberID = props.MemberID;
            d.StartDate = DateFormatJSON(getValues('Start'),false);
            d.EndDate = DateFormatJSON(getValues('End'),false);
            if(getValues('StoreID') != ''){
                d.StoreID = getValues('StoreID');
            }
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
        </div>
    )
    const _column = [
        {data: "TransactionDate", name: "Created", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        { data: "StoreCode", name: "StoreCode", autoWidth: true },
        { data: "StoreName", name: "StoreName", autoWidth: true },
        { data: "Amount", name: "Amount", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "TransactionStatusName", name: "st", autoWidth: true },
        { data: "ReasonName", name: "Reason", autoWidth: true },
        {
            data: "TransactionID", name: "TransactionID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    
    const _ColumnDefs = [
    ]
    
    return (
        <>
        <div className='row justify-content-end'>
            <div className='col-4'>
                <select className='form-control text-left' defaultValue={''} onChange={(e)=>{setValue("StoreID",e.target.value); setTimeout(()=>{_ref.current.load();},200);}} >
                    <option value={''} className='text-center' selected>ทั้งหมด</option>
                    {_StoreList.map((v,i)=>(
                        <option key={i} value={v.StoreId}>{v.StoreCode} | {v.StoreName}</option>
                    ))}
                </select>
            </div>
            <div className='col-2 text-end'>
                <ThaiDatePicker
                    className='form-control text-center'
                    selectsStart
                    selected={_StartDate}
                    onChange={(date) => { setStartDate(date); setValue('Start',date); setTimeout(()=>{_ref.current.load();},200); }}
                    startDate={_StartDate}
                    endDate={_EndDate}
                    placeholderText="วันที่ เริ่มต้น"
                />
            </div>
            <div className='col-2 text-end'>
                <ThaiDatePicker
                    className='form-control text-center'
                    selectsEnd
                    selected={_EndDate}
                    onChange={(date) => { setEndDate(date); setValue('End',date); setTimeout(()=>{_ref.current.load();},200); }}
                    startDate={_StartDate}
                    endDate={_EndDate}
                    minDate={_StartDate}
                    placeholderText="วันที่ สิ้นสุด"
                />
            </div>
        </div>
        <div className='row'>
           <div className="col-lg-12 table-responsive">
                <table id="TransactionTableView" className='table w-100' role='grid'>
                    <thead>
                        <tr>
                            <th className="text-center textcenter">วันที่ / เวลา</th>
                            <th className="text-center textcenter">รหัสร้านค้า</th>
                            <th className="text-center textleft">ชื่อร้านค้า</th>
                            <th className="text-center textcenter">ยอดเงิน</th>
                            <th className="text-center textcenter no-sortr">สถานะ</th>
                            <th className="text-center textcenter no-sort">หมายเหตุ</th>
                            <th className="text-center no-sort"></th>
                        </tr>
                    </thead>
                    <DataTable TableID={"TransactionTableView"} Column={_column} Configs={_configs} ref={_ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                </table>
            </div>
        </div>
        </>
    );

});

export default React.memo(TransactionCard)